/**
 * Bouton "Annuler" affiché pendant toute session de dessin (rectangle OU polygone) en cours —
 * indépendant du tutoriel (`ui/DrawTutorial`) : piloté par les évènements `MapAdapterEvent`
 * `"drawing:started"`/`"drawing:ended"` (voir `createTokaMap`), qui sont émis inconditionnellement
 * par `MapLibreAdapter`, contrairement à `"drawing:tutorial-step"`/`"drawing:tutorial-ended"` (qui
 * respectent `StartDrawingOptions.skipTutorial`) — ce bouton reste donc affiché même quand le
 * tutoriel est désactivé pour la session en cours.
 */
export class CancelDrawingButton {
  private element: HTMLButtonElement | null = null;

  constructor(
    private container: HTMLElement,
    private onCancel: () => void,
  ) {}

  show(): void {
    if (this.element) return;

    this.element = document.createElement("button");
    this.element.type = "button";
    this.element.className = "toka-cancel-drawing-button";
    this.element.textContent = "✕ Annuler";
    this.element.addEventListener("click", this.onCancel);
    this.container.appendChild(this.element);
  }

  hide(): void {
    this.element?.remove();
    this.element = null;
  }
}
